// Curated media for Phaedra Paulson — motion-first.

// Kingsley — Phaedra's own clothing line (M. Kingsley Studio).
export const kg = (name) => `/kingsley/${name}.webp`;
export const KINGSLEY_LOGO = "/kingsley/logo.webp";
export const KINGSLEY_LOGO_INK = "/kingsley/logo-ink.webp";
export const KINGSLEY_PIECES = [
  { slug: "column-vdress-red", name: "The Column", note: "Bias column dress · crimson" },
  { slug: "millie-sleeveless-red", name: "The Millie", note: "Draped sleeveless dress · crimson" },
  { slug: "aline-vdress-grey", name: "The A-Line", note: "Ruched V-neck dress · charcoal" },
  { slug: "asymmetrical-grey", name: "The Asymmetric", note: "Gathered midi · charcoal" },
  { slug: "shrug-red", name: "The Shrug", note: "Draped shrug over slip · crimson & charcoal" },
  { slug: "sweatshirt-brown-boyfriend", name: "The Boyfriend", note: "Cowl sweatshirt · espresso" },
  { slug: "bluezigzag-shrug", name: "The Zigzag", note: "Hand-knit shrug · marled blue" },
  { slug: "millie-brown", name: "The Millie", note: "Draped dress · espresso" },
  { slug: "sweatshirt-white-cropped", name: "The Cropped", note: "Cowl sweatshirt · bone" },
  { slug: "millie-sleeveless-red-short", name: "The Millie, Short", note: "Draped mini · crimson" },
  { slug: "sweatshirt-brown", name: "The Sweatshirt", note: "Cowl-neck · espresso" },
];

// On-figure campaign lookbook — the pieces, worn.
export const KINGSLEY_INSTAGRAM = "https://www.instagram.com/mkingsleystudio/";
export const KINGSLEY_INSTAGRAM_HANDLE = "@mkingsleystudio";
export const KINGSLEY_LOOKBOOK = [
  { slug: "model-duo", name: "Together", note: "The Column dress · crimson & charcoal" },
  { slug: "model-cowl-red", name: "The Cowl", note: "Draped cowl-neck dress · crimson" },
  { slug: "model-shrug-column", name: "The Shrug", note: "Draped shrug over the column dress · charcoal" },
  { slug: "model-stripe-maxi", name: "The Stripe", note: "Bias-cut maxi · black & bone" },
  { slug: "model-offshoulder", name: "The Off-Shoulder", note: "Cowl sweatshirt, worn low · charcoal" },
];

// Maker — Phaedra's hands-on / nature-artist practice (standalone sub-site).
export const mk = (name) => `/maker/${name}.webp`;
export const MAKER_HERO = "/maker/maker-dyehero.webp";
export const MAKER_HAT_HERO = "/maker/work-hero.webp";
export const MAKER_QUILTS = [
  { slug: "quilt-01", name: "Log Cabin", note: "Rust & bronze scraps" },
  { slug: "quilt-02", name: "The Maze", note: "Teal-bordered, full colour" },
  { slug: "quilt-03", name: "The Maze", note: "Improvised, full colour" },
  { slug: "quilt-04", name: "Concentric", note: "Black, white & ash" },
];
// Grouped Maker collections — each opens as its own lightbox gallery.
export const MAKER_STUDIO = ["p-1790", "p-1798", "p-2067", "p-1952", "p-1875", "p-2150", "p-1933", "p-2179", "p-0742"];
export const MAKER_HEADPIECES = ["h-2223", "h-2186", "h-3733", "h-3575", "h-3788", "h-4140", "m-8140", "m-7974", "m-8616", "m-5131", "m-8929", "m-9150"];
// Natural dyeing (backyard, with friends & daughter → drying → worn) and jewelry/found things.
export const MAKER_DYE = ["dye-01", "dye-02", "dye-03", "dye-04", "dye-05", "dye-06", "dye-07", "dye-08", "dye-09", "dye-10", "dye-11", "dye-12", "dye-13", "dye-14", "dye-15", "dye-16", "dye-17", "dye-18"];
export const MAKER_JEWELRY = ["jewel-01", "jewel-02", "jewel-03", "jewel-04", "jewel-05"];
export const MAKER_GARDEN = "/maker/garden-01.webp";

export const img = (n) => `/assets/img_${String(n).padStart(2, "0")}.jpg`;export const vid = (n) => `/videos/vid_${String(n).padStart(2, "0")}.mp4`;
export const vidPoster = (n) => `/videos/vid_${String(n).padStart(2, "0")}.jpg`;
export const gs = (name) => `/gallery_stills/${name}.webp`;

// Hero centerpiece — a moving portrait with sound the visitor can turn on.
export const HERO_VIDEO = {
  src: "/videos/vid_hero_audio.mp4",
  webm: "/videos/vid_hero_audio.webm",
  poster: "/videos/vid_hero_audio.jpg",
  sound: true,
};

export const HERO_VIDEO_ALT = { src: vid(19), poster: vidPoster(19) };

// Selected showcase reels (vertical), deduped. mp4 (H.264) + webm (VP9) + poster.
// Removed duplicate clips: reel_27 (=08), reel_35 (=07), reel_36 (=15).
const DUPLICATE_REELS = [20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 32, 33, 34, 35, 36];
const REEL_NUMS = Array.from({ length: 36 }, (_, i) => i + 1).filter(
  (n) => !DUPLICATE_REELS.includes(n)
);
const reelFor = (n) => {
  const s = String(n).padStart(2, "0");
  return {
    id: `reel-${s}`,
    src: `/reels_new/reel_${s}.mp4`,
    webm: `/reels_new/reel_${s}.webm`,
    poster: `/reels_new/reel_${s}.jpg`,
  };
};
export const REELS = [50, ...REEL_NUMS].map(reelFor);

// Home "In Motion": a featured reel + a small supporting set. The rest live on
// the /reels ("more social media videos") page.
const HOME_REEL_NUMS = [5, 6, 9, 12, 15, 16, 17];
export const FEATURED_REEL = reelFor(16); // reel_16 — the highlight
export const HOME_REELS = [5, 6, 9, 12, 15, 17].map(reelFor);
export const MORE_REELS = REELS.filter(
  (r) => !HOME_REEL_NUMS.includes(Number(r.id.slice(5)))
);

// Behind-the-scenes clips (landscape + studio) — shown on the Studio page.
export const BTS_REELS = [
  ...[
    { num: 38, label: "On set — tennis campaign" },
    { num: 40, label: "Behind the scenes" },
    { num: 41, label: "Behind the scenes" },
  ].map(({ num, label }) => {
    const n = String(num).padStart(2, "0");
    return { id: `bts-${n}`, label, src: `/reels_new/reel_${n}.mp4`, webm: `/reels_new/reel_${n}.webm`, poster: `/reels_new/reel_${n}.jpg` };
  }),
  // bts_v06 removed — it was a trimmed segment of reel_41 (same footage, duplicate).
  ...Array.from({ length: 5 }, (_, i) => {
    const n = String(i + 1).padStart(2, "0");
    return { id: `bts-v${n}`, label: "In the studio", src: `/bts/bts_v${n}.mp4`, webm: `/bts/bts_v${n}.webm`, poster: `/bts/bts_v${n}.jpg` };
  }),
];

// Behind-the-scenes stills — the making, pinning and process.
export const BTS_STILLS = [
  { src: "/bts/bts_p01.webp", alt: "Pinning the sample, pink knit" },
  { src: "/bts/bts_p02.webp", alt: "Fitting the blue set, in progress" },
  { src: "/bts/bts_p03.webp", alt: "Pinning the blue set" },
  { src: "/bts/bts_p04.webp", alt: "On location, between looks" },
  { src: "/bts/bts_p05.webp", alt: "Studio bench, tools of the trade" },
  { src: "/bts/bts_p06.webp", alt: "Cutting & marking, close up" },
  { src: "/bts/bts_p07.webp", alt: "Working the pattern" },
  { src: "/bts/bts_p08.webp", alt: "Late-night studio session" },
  { src: "/bts/bts_p09.webp", alt: "Shaping the piece" },
  { src: "/bts/bts_p10.webp", alt: "Detail work in progress" },
  { src: "/bts/bts_p11.webp", alt: "Finishing touches" },
  { src: "/bts/bts_s01.webp", alt: "Styling the product table, overhead" },
  { src: "/bts/bts_s02.webp", alt: "Setting up the shot" },
  { src: "/bts/bts_s03.webp", alt: "On set, dialing in the light" },
  { src: "/bts/bts_s04.webp", alt: "Fitting shoes between looks" },
  { src: "/bts/bts_s05.webp", alt: "Styling with the softbox" },
  { src: "/bts/bts_s06.webp", alt: "Styling on location" },
  { src: "/bts/bts_s07.webp", alt: "Colour swatches and product, on set" },
  { src: "/bts/bts_s08.webp", alt: "Laying out the swatches" },
  { src: "/bts/bts_s09.webp", alt: "Shooting accessories on the table" },
  { src: "/bts/bts_s10.webp", alt: "Working it out together at the bench" },
  { src: "/bts/bts_s11.webp", alt: "Fitting the floral dress on the stand" },
];

// Three great stills interspersed with the videos on the home page.
export const HOME_STILLS = [
  { src: gs("dbx-10"), alt: "Tennis dress, cream & burgundy" },
  { src: gs("dbx-27"), alt: "Blush knit, gold skirt" },
];

// Curated still galleries — Dropbox editorial-forward edit.
export const GALLERIES = [
  {
    id: "editorial",
    title: "Editorial & Fashion",
    note: "High-fashion and lifestyle editorial — mood, movement and light.",
    images: [
      { src: gs("dbx-08"), alt: "Cream cardigan, stone steps" },
      { src: gs("dbx-10"), alt: "Tennis dress, cream & burgundy" },
      { src: gs("dbx-11"), alt: "Sage knit by the arched door" },
      { src: gs("dbx-09"), alt: "Navy knit set on the steps" },
      { src: gs("dbx-07"), alt: "Denim styling, campus duo" },
      { src: gs("dbx-15"), alt: "Olive & sage, campus walk" },
      { src: gs("dbx-24"), alt: "Denim & olive, city steps" },
      { src: gs("dbx-27"), alt: "Blush knit, gold skirt" },
      { src: gs("dbx-44"), alt: "Blush pencil skirt, city stoop" },
      { src: gs("dbx-45"), alt: "Movement study, studio floor" },
      { src: gs("editorial-01"), alt: "Editorial gown, terracotta drape" },
      { src: gs("editorial-02"), alt: "Editorial gown, emerald back" },
      { src: gs("editorial-04"), alt: "Editorial duo, red & black" },
      { src: gs("editorial-06"), alt: "Editorial, draped charcoal" },
      { src: gs("dbx-02"), alt: "Western styling, desert duo" },
    ],
  },
  {
    id: "jewelry",
    title: "Fine Jewelry & Diamonds",
    note: "Luxe close-ups and editorial jewelry work — light, facet and craft.",
    images: [
      { src: gs("jewelry-12"), alt: "Art Deco diamond bracelet on emerald silk" },
      { src: gs("jewelry-13"), alt: "Fine watches — Cartier, Rolex & Piaget" },
      { src: gs("jewelry-14"), alt: "Diamond tennis necklaces & bands" },
      { src: gs("jewelry-15"), alt: "Gold chain & link collection" },
      { src: gs("jewelry-16"), alt: "Colored gemstone tennis suite" },
      { src: gs("jewelry-17"), alt: "Gemstone rings & opal pendant" },
      { src: gs("jewelry-18"), alt: "Antique diamond rings & cluster earrings" },
      { src: gs("jewelry-01"), alt: "Grown Brilliance, diamond editorial" },
      { src: gs("jewelry-36"), alt: "Grown Brilliance, diamond editorial" },
      { src: gs("jewelry-05"), alt: "Green stone pendant" },
      { src: gs("jewelry-30"), alt: "Gold chain with green drop pendant" },
      { src: gs("jewelry-34"), alt: "Gold beaded tennis necklace" },
      { src: gs("jewelry-35"), alt: "Gold link chain necklace" },
      { src: gs("jewelry-32"), alt: "Gold petal drop earrings" },
      { src: gs("jewelry-33"), alt: "Black & gold petal earrings" },
      { src: gs("jewelry-31"), alt: "Blue resin hoop earrings" },
    ],
  },
  {
    id: "product",
    title: "Accessories & Product",
    note: "Bags, footwear and product work — texture, colour story and craft.",
    images: [
      { src: gs("product-04"), alt: "Quilted handbag, black & white" },
      { src: gs("product-05"), alt: "Diamond-quilted handbag" },
      { src: gs("product-06"), alt: "Black leather crossbody" },
      { src: gs("product-18"), alt: "Backpacks on the rocks" },
      { src: gs("dbx-41"), alt: "Ballet flats, colour study" },
      { src: gs("product-27"), alt: "Paris hoodie, front" },
      { src: gs("product-26"), alt: "Camel bomber jacket" },
      { src: gs("product-29"), alt: "Red tweed jacket" },
      { src: gs("product-30"), alt: "Rust faux-fur cropped jacket" },
      { src: gs("product-34"), alt: "Green cargo trousers" },
      { src: gs("campaign-14"), alt: "Fragrance campaign, paper hearts" },
    ],
  },
];
